import { Injectable } from '@angular/core';
import { LoggingService } from '../../logging/logic/logging.service';
import {
  RequiredUserAction,
  RequiredUserActionParams,
  RequiredUserActionValidator,
} from '../required-user-action-service';
import { RemoteActionService } from '../../remote-action/logic/remote-action.service';
import { RemoteAction } from 'src/app/_model/remote-action/remote-action';
import { ClientStateService } from '../../client-state/logic/client-state.service';
import { AlertService } from '../../alert/alert.service';
import { LoadingService } from '../../loading/loading.service';
import { TranslateService } from '@ngx-translate/core';
import { ServicejobsService } from '../../servicejobs/logic/servicejobs.service';
import { JobSectionsService } from '../../job-section/logic/job-section.service';
import { DynFormsService } from '../../dyn-forms/logic/dyn-forms.service';

const DAY_TO_MILLISECONDS = 1000 * 60 * 60 * 24

@Injectable({
  providedIn: 'root',
})
export class NeedsDynFormRequiredUserAction implements RequiredUserActionValidator {
  // Public Member
  public readonly type: RequiredUserAction = 'needsdynform';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private translate: TranslateService,
    private clientStateService: ClientStateService,
    private alertService: AlertService,
    private loadingService: LoadingService,
    private servicejobsService: ServicejobsService,
    private dynFormsService: DynFormsService
  ) {}

  // RequiredUserActionService
  public async isFullfilled(
    params: RequiredUserActionParams,
  ): Promise<boolean> {
    this.logger.log(
      this.constructor.name,
      'JBKRK isFullfilled with',
      params,
    );

    const syscode = params?.['syscode']
    if (syscode == null) {
      this.logger.warn(this.constructor.name, "Cannot execute validator without defined syscode")
      return true;
    }
    const maxDayAge = params?.['maxdayage']

    const clientState = this.clientStateService.theState.getValue()
    if (clientState == null) {
      return true
    }

    const sjobId = clientState.serviceJobId
    if (sjobId == null) {
      return true
    }

    const serviceJob = this.servicejobsService.getServiceJobById(sjobId)
    if (serviceJob == null) {
      return null
    }

    const submittedDynFormSyscodesTstamps = serviceJob.submittedDynFormSyscodesTstamps;
    console.log("JBKRK ssubmittedDynFormSyscodesTstamps", submittedDynFormSyscodesTstamps)

    if (submittedDynFormSyscodesTstamps == null) {
      return false
    }

    const requiredTstamp = submittedDynFormSyscodesTstamps[syscode]
    console.log("JBKRK tstamp", requiredTstamp)

    if (requiredTstamp == null) {
      return false
    }
    
    if (maxDayAge == null) {
      return true
    } else {
      const curTstamp = new Date().getTime()
      console.log("JBKRK max day age found check if tstamp is not too old", maxDayAge, requiredTstamp, curTstamp, curTstamp-maxDayAge*DAY_TO_MILLISECONDS)
      if (curTstamp-maxDayAge*DAY_TO_MILLISECONDS > requiredTstamp) {
        console.log("JBKRK form is to old")
        return false
      } else {
        return true
      }
    }
  }

  public async showSoftWarning(
    params: RequiredUserActionParams,
  ): Promise<boolean> {
    await this.loadingService.dismissLoading();
    const returnPromise = new Promise<boolean>(async (resolve) => {
      await this.alertService.showAlert(
        this.translate.instant('REQUIRED-USER-ACTION.NEEDSDYNFORM.SOFT.TITLE'),
        undefined,
        this.translate.instant(
          'REQUIRED-USER-ACTION.NEEDSDYNFORM.SOFT.MESSAGE',
          this.getTranslateObjectForParams(params),
        ),
        this.translate.instant('REQUIRED-USER-ACTION.NEEDSDYNFORM.SOFT.CONFIRM'),
        async () => {
          await this.loadingService.showLoading();
          resolve(true);
        },
        async () => {
          await this.loadingService.showLoading();
          resolve(false);
        },
        [],
        true,
        undefined,
        this.translate.instant('REQUIRED-USER-ACTION.NEEDSDYNFORM.SOFT.CANCEL'),
        [],
      );
    });

    return returnPromise;
  }
  public async showHardWarning(
    params: RequiredUserActionParams,
  ): Promise<void> {
    await this.loadingService.dismissLoading();
    const returnPromise = new Promise<void>(async (resolve) => {
      await this.alertService.showAlert(
        this.translate.instant('REQUIRED-USER-ACTION.NEEDSDYNFORM.HARD.TITLE'),
        undefined,
        this.translate.instant(
          'REQUIRED-USER-ACTION.NEEDSDYNFORM.HARD.MESSAGE',
          this.getTranslateObjectForParams(params),
        ),
        undefined,
        undefined,
        async () => {
          await this.loadingService.showLoading();
          resolve();
        },
        [],
        true,
        undefined,
        this.translate.instant('REQUIRED-USER-ACTION.NEEDSDYNFORM.HARD.CANCEL'),
        [],
      );
    });

    return returnPromise;
  }

  // Private Functions
  private getTranslateObjectForParams(params: RequiredUserActionParams): any {
    let transObject = {};
    const clientState = this.clientStateService.theState.getValue();
    
    const dynForms = this.dynFormsService.dynForms$.getValue();
    console.log("JBKRK Found available dynforms with syscode", dynForms.map(it => it.dynFormTypeSyscode))

    const requiredDynForms = dynForms?.filter(it => it.dynFormTypeSyscode == params?.['syscode']).map(it => it.displayLabel)

    if (requiredDynForms == null || requiredDynForms.length == 0) {
       transObject['object'] = this.translate.instant(
        'REQUIRED-USER-ACTION.NEEDSDYNFORM.UNKNOWN-OBJECT',
      );
    } else {
      transObject['object'] = requiredDynForms.join(", ")
    }

    return transObject;
  }
}
